module.exports = __webpack_public_path__ + "static/img/A155.f1cc5578.jpg";